import { Host, h } from '@stencil/core';
import classNames from '../../../utils/classnames.utils';
export class AibaLoadingBar {
  constructor() {
    this.loadingText = undefined;
    this.loadingTextOrientation = 'above';
    this.loadingTextPosition = 'outside';
    this.styles = undefined;
    this.classes = undefined;
  }
  getCssClassMap() {
    return classNames(`loading-bar ${this.classes ? this.classes : ''}`);
  }
  render() {
    return (h(Host, null, this.styles && h("style", null, this.styles), h("div", { class: this.getCssClassMap() }, this.loadingTextPosition === 'inside' ? (h("div", { class: `loading-bar__wrapper loading-bar__wrapper-${this.loadingTextPosition}` }, h("div", { class: `loading-bar__wrapper__loader-default loading-bar__wrapper-${this.loadingTextPosition}__loader-default` }, h("div", { class: `loading-bar__wrapper__loader-default__text ${this.classes && `${this.classes}`}` }, this.loadingTextPosition === 'inside' && this.loadingText)))) : (h("div", null, h("div", { class: "loading-bar__text-above" }, this.loadingTextOrientation === 'above' && this.loadingText), h("div", { class: `loading-bar__wrapper loading-bar__wrapper-${this.loadingTextPosition}` }, h("div", { class: `loading-bar__wrapper__loader-default loading-bar__wrapper-${this.loadingTextPosition}__loader-default` })), h("div", { class: "loading-bar__text-below" }, this.loadingTextOrientation === 'below' && this.loadingText))))));
  }
  static get is() { return "aiba-loading-bar"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-loading-bar.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-loading-bar.css"]
    };
  }
  static get properties() {
    return {
      "loadingText": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "loading-text",
        "reflect": false
      },
      "loadingTextOrientation": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "'above' | 'below'",
          "resolved": "\"above\" | \"below\"",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "loading-text-orientation",
        "reflect": false,
        "defaultValue": "'above'"
      },
      "loadingTextPosition": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "'outside' | 'inside'",
          "resolved": "\"inside\" | \"outside\"",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "loading-text-position",
        "reflect": false,
        "defaultValue": "'outside'"
      },
      "styles": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "styles",
        "reflect": false
      },
      "classes": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "classes",
        "reflect": false
      }
    };
  }
}
//# sourceMappingURL=aiba-loading-bar.js.map
